export const MARK_ALL_AS_READ = 'markAllAsRead';
